import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../translation/translation';

function FSHomePageLightBoxContent({ onProceed }) {
    return (
        <div className="fs-home-page-light-box__content fs-home-page-light-box-content">
            <div className="progress-list">
                <p className="progress-list__item progress-list-item progress-list-item--active">
                    <strong className="progress-list-item__headline">
                        <Translation translationKey="fs-home-page-light-box-progress-first-headline" />
                    </strong>
                    <Translation translationKey="fs-home-page-light-box-progress-first-text" />
                </p>
                <p className="progress-list__item progress-list-item">
                    <strong className="progress-list-item__headline">
                        <Translation translationKey="fs-home-page-light-box-progress-second-headline" />
                    </strong>
                    <Translation translationKey="fs-home-page-light-box-progress-second-text" />
                </p>
                <p className="progress-list__item progress-list-item">
                    <strong className="progress-list-item__headline">
                        <Translation translationKey="fs-home-page-light-box-progress-third-headline" />
                    </strong>
                    <Translation translationKey="fs-home-page-light-box-progress-third-text" />
                </p>
                <p className="progress-list__item progress-list-item">
                    <strong className="progress-list-item__headline">
                        <Translation translationKey="fs-home-page-light-box-progress-fourth-headline" />
                    </strong>
                    <Translation translationKey="fs-home-page-light-box-progress-fourth-text" />
                </p>
            </div>

            <div className="fs-home-page-light-box-content__call-us">
                <button className="fs-home-page-light-box-content__cta" onClick={onProceed}>
                    <Translation translationKey="fs-home-page-light-box-cta-text" />
                </button>
            </div>
        </div>
    );
}

FSHomePageLightBoxContent.propTypes = {
    onProceed: PropTypes.func.isRequired,
};

export { FSHomePageLightBoxContent };
